// PageBreak.jsx
import React from "react";
import styled from "styled-components";

const Break = styled.div`
  display: none;

  @media print {
    display: block;
    page-break-after: always;
  }
`;

const Margin = styled.div`
  display: none;

  @media print {
    display: block;
    height: 60px; /* top margin on new printed page */
  }
`;

const PageBreak = () => (
  <>
    <Break />
    <Margin />
  </>
);

export default PageBreak;
